import script from "./DonorRecognitionAndBenefitStructureView.vue?vue&type=script&setup=true&lang=js"
export * from "./DonorRecognitionAndBenefitStructureView.vue?vue&type=script&setup=true&lang=js"

import "./DonorRecognitionAndBenefitStructureView.vue?vue&type=style&index=0&id=14671653&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14671653"]])

export default __exports__